import React from 'react'
import { Checkbox, Space } from 'antd'
import useQueryParam from '../../../../../../hooks/useQueryParam'
import { CONFIDENCE_LEVELS_PARAM } from '../../../../../../constants/query-params'
import useQueryParamSetter from '../../../../../../hooks/useQueryParamSetter'
import { ConfidenceLevels, getConfidenceLevelName } from '../../../../../../constants/confidence-levels'

const ConfidenceFilters = () => {
    const queryParam = useQueryParam(CONFIDENCE_LEVELS_PARAM)
    const setQueryParam = useQueryParamSetter()

    const allConfidenceLevels = Object.values(ConfidenceLevels).map(level => String(level))
    let confidenceLevels = queryParam ? queryParam.split(',') : []

    const options = allConfidenceLevels.map(level => (
        <Checkbox key={level} value={level}>
            {getConfidenceLevelName(Number(level))}
        </Checkbox>
    ))

    const handleChange = checkedValues => {
        setQueryParam({ [CONFIDENCE_LEVELS_PARAM]: checkedValues.join(',') })
    }

    return (
        <Checkbox.Group onChange={handleChange} value={confidenceLevels}>
            <Space direction='vertical'>{options}</Space>
        </Checkbox.Group>
    )
}

export default ConfidenceFilters
